jQuery(function ($) {
    "use strict";

    var Engine = {
        ui: {
            misc: function () {

                // Scroll to top functionality
                $(window).on('scroll', function () {
                    if ($(this).scrollTop() > 1000) {
                        $('#return-to-top').fadeIn();
                        $("#return-to-top").addClass('active');
                    } else {
                        $('#return-to-top').fadeOut();
                        $("#return-to-top").removeClass('active');
                    }
                });

                $('#return-to-top').on('click', function () {
                    $('body,html').animate({
                        scrollTop: 0
                    }, 100);
                    return false;
                });

                // Mobile navigation toggle
                $('#showMobileNav').on('click', () => {
                    $('.mobileNav').toggleClass('hidden');
                });

                let isOpen = false;

                // Hamburger menu transition
                $("#menuIcon").on('click', function () {
                    if (!isOpen) {
                        $('.top').attr('d', 'M1 1L19 15');
                        $('.middle').css('opacity', '0');
                        $('.bottom').attr('d', 'M1 15L19 1');
                    } else {
                        $('.top').attr('d', 'M2 2H25');
                        $('.middle').css('opacity', '1');
                        $('.bottom').attr('d', 'M2 18H25');
                    }
                    isOpen = !isOpen;
                });

                // Sliders (for stages, events, and timelines)
                $('.stages-slider').slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    arrows: true,
                    infinite: false,
                    autoplay: false,
                    prevArrow: $(".prevstage"),
                    nextArrow: $(".nextstage"),
                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 3,
                                arrows: false,
                                dots: true,
                            }
                        },
                        {
                            breakpoint: 800,
                            settings: {
                                slidesToShow: 2,
                                arrows: false,
                                dots: true,
                            }
                        },
                        {
                            breakpoint: 540,
                            settings: {
                                slidesToShow: 1,
                                arrows: false,
                                dots: true,
                            }
                        }
                    ]
                });

                $('.events-slider').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                    infinite: false,
                    autoplay: false,
                });

                $('.timeline-slider').slick({
                    dots: false,
                    arrows: true,
                    infinite: false,
                    autoplay: true,
                    speed: 300,
                    slidesToShow: 1,
                    adaptiveHeight: true,
                    prevArrow: $(".prevtimeline"),
                    nextArrow: $(".nexttimeline")
                });

                // Accordion functionality
                $('.accordion-button').on('click', function () {
                    $(this).toggleClass('bg-secondary text-white');
                    $(this).next('.accordion-content').toggleClass('hidden max-h-0 max-h-full');
                    $(this).find('.accordion-arrow').toggleClass('rotate-0 rotate-180');
                });

                $('#expand-all').on('click', function () {
                    if ($(this).text() === 'Expand All') {
                        $('.accordion-button').addClass('bg-secondary text-white');
                        $('.accordion-content').removeClass('hidden max-h-0').addClass('max-h-full');
                        $('.accordion-arrow').removeClass('rotate-0').addClass('rotate-180');
                        $(this).text('Close All');
                    } else {
                        $('.accordion-button').removeClass('bg-secondary text-white');
                        $('.accordion-content').addClass('hidden max-h-0').removeClass('max-h-full');
                        $('.accordion-arrow').removeClass('rotate-180').addClass('rotate-0');
                        $(this).text('Expand All');
                    }
                });

                if ($('.accordion-button').first().hasClass('bg-secondary')) {
                    $('#expand-all').text('Expand All');
                }

                // Membership form handling
                const membershipTypeInput = $('#membership-type-input');
                const additionalDonation = $('#additional-donation');
                const organisationNameInput = $('#organisation-name-input');
                const spouseInputs = $('#spouse-full-name-input, #spouse-email-address-input, #spouse-phone-number-input');
                const paymentTypeInputs = $('input[name="payment-type"]');
                const membershipForm = $('#wpcf7-f80-o1');
                const membershipTypeSelect = $('.membershipTypeSelect');
                const conditionalInputs = organisationNameInput.add(spouseInputs);

                conditionalInputs.prop('disabled', true).hide();
                const initialMembershipType = membershipTypeInput.val();

                function updateFormFields() {
                    const selectedType = $.trim(membershipTypeInput.val());
                    console.log('Membership Type Selected:', selectedType);

                    conditionalInputs.prop('disabled', true).hide().val('');

                    if (selectedType === 'Organisational Member - Not for Profit' ||
                        selectedType === 'Organisational Member - Business') {
                        organisationNameInput.prop('disabled', false).show();
                    } else if (selectedType === 'Family Life Member') {
                        spouseInputs.prop('disabled', false).show();
                    }
                }

                updateFormFields();
                membershipTypeInput.on('change', updateFormFields);

                membershipTypeSelect.on('click', function () {
                    const value = $(this).data('val');
                    membershipTypeInput.val(value).trigger('change');
                    console.log('Membership Type Input Updated:', value);
                });

                $('#attach-receipt').hide();

                paymentTypeInputs.on('change', function () {
                    membershipTypeInput.trigger('change');
                    const selectedPayment = paymentTypeInputs.filter(':checked').val();
                    console.log('Payment Plan Selected:', selectedPayment);

                    const attachReceipt = $('#attach-receipt');
                    if (selectedPayment === 'EFT Transfer') {
                        attachReceipt.prop('disabled', false).show();
                    } else {
                        attachReceipt.prop('disabled', true).hide();
                    }
                });

                // Form submission handling
                document.addEventListener('wpcf7submit', function (event) {
                    if (event.detail.contactFormId == '80') {
                        const selectedPayment = paymentTypeInputs.filter(':checked').val();
                        console.log('Payment Plan Selected:', selectedPayment);

                        if (event.detail.status === 'validation_failed') {
                            console.log('Form validation failed. No redirection or Stripe processing.');
                            return;
                        }

                        if (selectedPayment === 'Pay by Card (Full Payment)' ||
                            selectedPayment === 'Pay by Card (4x Installments)' ||
                            selectedPayment === 'Pay by Card (12x Installments)') {
                            console.log('Stripe Payment Selected.');

                            $.ajax({
                                url: '/wp-admin/admin-ajax.php',
                                method: 'POST',
                                data: {
                                    action: 'create_stripe_session',
                                    donation: $.trim(additionalDonation.val()),
                                    membershipType: $.trim(membershipTypeInput.val()),
                                    paymentPlan: selectedPayment,
                                    email: $('input[name="your-email"]').val()
                                },
                                success: function (response) {
                                    if (response.success) {
                                        console.log('Stripe session created. Redirecting to checkout.');
                                        Stripe('pk_live_51Pi4so2NEKjHmHzaFSyxnwMmQLotxQA79yEDDI6clv6hAah04TGUX2WfCaQVD0QsPs1KCS47BXnpiMh6PVJjehJV00QuFwEJlb')
                                            .redirectToCheckout({ sessionId: response.data.session_id });
                                    } else {
                                        alert('Payment processing failed: ' + response.data.message);
                                        console.error('Stripe Error:', response.data.message);
                                    }
                                },
                                error: function (xhr, status, error) {
                                    console.error('AJAX Error:', status, error);
                                }
                            });
                        } else if (selectedPayment === 'EFT Transfer') {
                            console.log('EFT Transfer Selected.');
                            membershipForm.submit();
                            setTimeout(function () {
                                window.location.href = '/membership-photos';
                            }, 500);
                        }

                        // Store form data
                        var firstName = $('input[name="your-firstname"]').val();
                        var lastName = $('input[name="your-lastname"]').val();
                        var spouseName = $('input[name="your-spouse-name"]').val();
                        var organisation = $('input[name="your-organisation"]').val();
                        var membershipType = $('#membership-type-input').val();

                        localStorage.setItem('your-firstname', firstName);
                        localStorage.setItem('your-lastname', lastName);
                        localStorage.setItem('your-spouse-name', spouseName);
                        localStorage.setItem('your-organisation', organisation);
                        localStorage.setItem('your-membership-type', membershipType);
                    }
                }, false);

                // Suburb autocomplete
                var suburbs = [];
                $.ajax({
                    url: '/wp-content/themes/aiims/suburbs.csv',
                    dataType: 'text'
                }).done(function (data) {
                    Papa.parse(data, {
                        header: true,
                        skipEmptyLines: true,
                        complete: function (results) {
                            suburbs = results.data.map(function (row) {
                                return row.place_name;
                            });

                            $('#your-suburb').autocomplete({
                                source: suburbs,
                                minLength: 2,
                                select: function (event, ui) {
                                    $('#your-suburb').val(ui.item.value);
                                    $('#suburb-error').remove();
                                    return false;
                                },
                                change: function (event, ui) {
                                    if (ui.item) {
                                        $('#suburb-error').remove();
                                    } else {
                                        $('#your-suburb').val('');
                                        $('#suburb-error').remove();
                                        $('<p id="suburb-error" class="text-sm text-red-500">Please select a suburb from the list.</p>')
                                            .insertAfter('#your-suburb');
                                    }
                                }
                            });
                        }
                    });
                });

                document.addEventListener('wpcf7submit', function (event) {
                    var suburbValue = $('#your-suburb').val();
                    if (!suburbs.includes(suburbValue)) {
                        $('#suburb-error').remove();
                        $('<p id="suburb-error" class="text-sm text-red-500">Please select a suburb from the list.</p>')
                            .insertAfter('#your-suburb');
                        event.preventDefault();
                    } else {
                        $('#suburb-error').remove();
                    }
                }, false);

                // Donation form handling
                const donationOtherInput = $('input[name="donation-other"]');
                const donationAmountInputs = $('input[name="donation-amount"]');

                donationOtherInput.hide();

                donationAmountInputs.on('change', function () {
                    if ($(this).val() === 'Other') {
                        donationOtherInput.show();
                    } else {
                        donationOtherInput.hide();
                    }
                });

                document.addEventListener('wpcf7submit', function (event) {
                    if (event.detail.contactFormId == '694') {
                        if (event.detail.status === 'validation_failed') {
                            console.log('Form validation failed. No redirection or Stripe processing.');
                            return;
                        }

                        var formData = {
                            action: 'handle_donation',
                            'your-firstname': $('input[name="your-firstname"]').val(),
                            'your-lastname': $('input[name="your-lastname"]').val(),
                            'your-email': $('input[name="your-email"]').val(),
                            'donation-amount': $('input[name="donation-amount"]:checked').val(),
                            'donation-other': $('input[name="donation-other"]').val()
                        };

                        $.ajax({
                            url: '/wp-admin/admin-ajax.php',
                            method: 'POST',
                            data: formData,
                            success: function (response) {
                                if (response.success) {
                                    Stripe('pk_live_51Pi4so2NEKjHmHzaFSyxnwMmQLotxQA79yEDDI6clv6hAah04TGUX2WfCaQVD0QsPs1KCS47BXnpiMh6PVJjehJV00QuFwEJlb')
                                        .redirectToCheckout({ sessionId: response.data.session_id });
                                } else {
                                    alert('Payment processing failed: ' + response.data.message);
                                    console.error('Stripe Error:', response.data.message);
                                }
                            },
                            error: function (xhr, status, error) {
                                console.error('AJAX Error:', status, error);
                            }
                        });
                    }
                }, false);
            }
        }
    };

    Engine.ui.misc();
});

// Smooth scroll for form anchor
document.querySelectorAll('a[href="#localForm"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});
